/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetProducts200ResponseItemsInnerInformation
 */
export interface GetProducts200ResponseItemsInnerInformation {
    /**
     * 
     * @type {number}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    alcoholContent?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    basePrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    caffeineContent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    manufacturersInformation?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    netQuantity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    deposit?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    nutritionalInformation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    storageInformation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProducts200ResponseItemsInnerInformation
     */
    barcode?: string | null;
}

/**
 * Check if a given object implements the GetProducts200ResponseItemsInnerInformation interface.
 */
export function instanceOfGetProducts200ResponseItemsInnerInformation(value: object): value is GetProducts200ResponseItemsInnerInformation {
    return true;
}

export function GetProducts200ResponseItemsInnerInformationFromJSON(json: any): GetProducts200ResponseItemsInnerInformation {
    return GetProducts200ResponseItemsInnerInformationFromJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200ResponseItemsInnerInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'alcoholContent': json['alcoholContent'] == null ? undefined : json['alcoholContent'],
        'basePrice': json['basePrice'] == null ? undefined : json['basePrice'],
        'caffeineContent': json['caffeineContent'] == null ? undefined : json['caffeineContent'],
        'manufacturersInformation': json['manufacturersInformation'] == null ? undefined : json['manufacturersInformation'],
        'netQuantity': json['netQuantity'] == null ? undefined : json['netQuantity'],
        'deposit': json['deposit'] == null ? undefined : json['deposit'],
        'nutritionalInformation': json['nutritionalInformation'] == null ? undefined : json['nutritionalInformation'],
        'storageInformation': json['storageInformation'] == null ? undefined : json['storageInformation'],
        'barcode': json['barcode'] == null ? undefined : json['barcode'],
    };
}

export function GetProducts200ResponseItemsInnerInformationToJSON(json: any): GetProducts200ResponseItemsInnerInformation {
    return GetProducts200ResponseItemsInnerInformationToJSONTyped(json, false);
}

export function GetProducts200ResponseItemsInnerInformationToJSONTyped(value?: GetProducts200ResponseItemsInnerInformation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alcoholContent': value['alcoholContent'],
        'basePrice': value['basePrice'],
        'caffeineContent': value['caffeineContent'],
        'manufacturersInformation': value['manufacturersInformation'],
        'netQuantity': value['netQuantity'],
        'deposit': value['deposit'],
        'nutritionalInformation': value['nutritionalInformation'],
        'storageInformation': value['storageInformation'],
        'barcode': value['barcode'],
    };
}

